<template>
  <div>
    <div v-if="items === null" class="centerPage">
      <loader size="m"/>
    </div>
    <!-- <div v-else-if="error !== null">
      Erro ao carregar: {{ error }}
    </div> -->
    <div v-else-if="items.length == 0" class="blank-card">
      <md-card>
        <md-card-header>
          Nenhum {{ typeTxt }} encontrado :(
        </md-card-header>
      </md-card>
    </div>
    <div v-else class="item-list">
      <slot v-for="item in items" :item="item"></slot>
      <load-more
        :show="hasMore"
        :page="options.pagination.page"
        :pageSize="options.pagination.pageSize"
        @loadPage="loadPagination"
      />
    </div>
  </div>
</template>

<script>
import loadMore from "@/components/shared/loadMore";
import loader from "@/components/shared/loader";

export default {
  props: ["items", "typeTxt", "pageSize", "hasMore"],
  components: {
    loadMore,
    loader
  },
  data() {
    return {
      options: {
        pagination: {
          page: 0,
          pageSize: this.pageSize || 10
        }
      },
    }
  },
  methods: {
    loadPagination(pagination) {
      this.options.pagination = pagination;
      // load action (probably this.$emit)
      this.$emit("loadPage", this.options);
    },
  },
}
</script>

<style scoped>
.blank-card {
  width: 100%;
  padding: 16px;
  margin: 15px auto;
  /* transform: translateX(30px); */
}

.centerPage {
  position: absolute;
  padding: 50px;
  left: 50%;
  transform: translateX(-50%);
}

.item-list {
  display: flex;
  flex-flow: column;
}
</style>
